import { auth } from "./auth.js";
import { getState } from "./get-state.js";
import { VERSION } from "./version.js";
function createProbotAuthFn(options) {
  const state = getState(options);
  return Object.assign(auth.bind(null, state), {
    hook: state.auth.hook
  });
}
createProbotAuthFn.VERSION = VERSION;
const createProbotAuth = createProbotAuthFn;
export {
  createProbotAuth
};
